export default __webpack_public_path__ + "static/media/back-arrow-2.2f88d667.svg";